function resizeMacy() {
    if (jQuery(window).width() >= 475) {
        if (macyInstance !== undefined && macyInstance !== null) {
            macyInstance.recalculate(true);
            macyInstance.reInit();
        } else {
            macyItems('footer-menu');
        }
    } else {
        if (macyInstance !== null) {
            macyInstance.remove();
        }
    }
}

var macyInstance = null;

function macyItems(target) {
    // console.log(jQuery('#' + target));
    macyInstance = Macy({
        container: '#' + target + '',
        trueOrder: true,
        waitForImages: false,
        margin: 40,
        columns: 1,
        mobileFirst: true,
        breakAt: {
            475: 2,
            768: 3,
        }
    });
    jQuery(window).trigger('resize');
    resizeMacy();
    
}

slideBrands = function($) {
    $('.brand-slider .slide-holder .slide').each(function() {
        var _this = this;
        _this.classList.remove('animating');
        window.setTimeout(function() {
            _this.classList.add('animating');
        }, 12);
    });
    var firstSlideClone = $('.brand-slider .slide-holder .slide:first-child').clone();
    $('.brand-slider .slide-holder').append(firstSlideClone);
    $('.brand-slider .slide-holder .slide:first-child').remove();
    window.setTimeout(function() {
        slideBrands($);
    }, 2000);
}

jQuery(document).ready(function($) {
    var rtime;
    var timeout = false;
    var delta = 100;
    $(window).resize(function() {
        rtime = new Date();
        if (timeout === false) {
            timeout = true;
            setTimeout(resizeend, delta);
        }
    });

    function resizeend() {
        if (new Date() - rtime < delta) {
            setTimeout(resizeend, delta);
        } else {
            timeout = false;
            resizeMacy();
        }               
    }
    resizeMacy();
    if ($('.brand-slider').length) {
        //do slider stuff here
        // slideBrands($);
    }

    if ($('#hero-video').length) {
        var myVideo = document.getElementById("hero-video"); 
        myVideo.play(); 
    }

    $(window).bind('scroll', function() {
        //check if scroll amount is greater than 1 
        if ($(window).scrollTop() >= 1) {
            $('#masthead').removeClass('initial');
        } else {
            $('#masthead').addClass('initial');
        }
    });

    $('.featured-blocks-wrapper ol li a').bind('click', function(e){
        //remove the active class from other list items
        $('.featured-blocks-wrapper ol li').removeClass('active');
        $('.featured-blocks-wrapper ul li').removeClass('active');
        //add active class to the clicked item
        $(this).parent().addClass('active');
        var activeIndex = $(this).parent().index();
        $('.featured-blocks-wrapper ul li').eq(activeIndex).addClass('active');
        //scroll to the top of the featured blocks
        $(this).parents('.mobile-wrapper').removeClass('active');
        $(this).parents('.mobile-wrapper').find('> a').removeClass().addClass($(this).attr('class')).html($(this).html());
        $('html,body').animate({
            scrollTop: $('.featured-blocks-wrapper').offset().top - 100
        }, 500);
        e.preventDefault();
    });

    /* AJAX Basket Updater */

    var timeout;

    jQuery('div.woocommerce').on('change keyup mouseup', 'input.qty', function(){ // keyup and mouseup for Firefox support
        if (timeout != undefined) clearTimeout(timeout); //cancel previously scheduled event
        if (jQuery(this).val() == '') return; //qty empty, instead of removing item from cart, do nothing
        timeout = setTimeout(function() {
            jQuery('[name="update_cart"]').trigger('click');
        }, 500 );
    });

    /* AJAX Add to Cart */

    jQuery(function($) {

        $('form.cart').on('submit', function(e) {

            e.preventDefault();

            // Check to see if this is an external product by checking the form method
            if( $(this).attr('method') === 'get' ) {
                window.location = $(this).attr('action');
                return;
            }

            var form = $(this);
            form.block({ message: null, overlayCSS: { background: '#fff', opacity: 0.6 } });

            var formData = new FormData(form[0]);
            formData.append('add-to-cart', form.find('[name=add-to-cart]').val() );

            // Ajax action.
            $.ajax({
                url: wc_add_to_cart_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'add_to_cart' ),
                data: formData,
                type: 'POST',
                processData: false,
                contentType: false,
                complete: function( response ) {
                    response = response.responseJSON;

                    console.log(wc_add_to_cart_params);

                    if ( ! response ) {
                        return;
                    }

                    if ( response.error && response.product_url ) {
                        window.location = response.product_url;
                        return;
                    }

                    // Redirect to cart option
                    if ( wc_add_to_cart_params.cart_redirect_after_add === 'yes' ) {
                        window.location = wc_add_to_cart_params.cart_url;
                        return;
                    }

                    var thisbutton = form.find('.single_add_to_cart_button');
                    
                    // Get the current add to cart text to compensate for translations
                    var addToCart = $('.single_add_to_cart_button').html(); 

                    // Trigger event so themes can refresh other areas.
                    $(document.body).trigger('added_to_cart', [ response.fragments, response.cart_hash, thisbutton ] );

                    // Remove existing notices
                    $('.woocommerce-error, .woocommerce-message, .woocommerce-info').remove();

                    // Get the translations for "Added" from a data attribute we've added to the single product page
                    $('.single_add_to_cart_button').html($('.wc-product').data('added') + ' <span class="icon-tick"></span>');

					// Change button text after 4 seconds
                    setTimeout(function() {
						$('.single_add_to_cart_button').html(addToCart);
					}, 4 * 1000);

                    form.unblock();
                }
            });
        });
    });

	jQuery(document).ready(function($){
		$('body').on( 'adding_to_cart', function(data, $thisbutton){
			$($thisbutton).parent().block({ message: null, overlayCSS: { background: '#fff', opacity: 0.6 } });
		});

		$('body').on( 'added_to_cart', function(event, fragments, cart_hash, button){

			$(button).html($(button).data('added') + ' <span class="icon-tick"></span>');
			$(button).parent().unblock();

			// Change button text after 4 seconds
			setTimeout(function() {
				$(button).html($(button).data('add-to-cart'));
                $(button).removeClass('added');
			}, 4 * 1000);
		});
	});

    var is_sliding = false;

    $('.accordion-wrapper').each(function(){
        
        var _this = $(this);
        _this.find('ul li a').bind('click', function(e){
            //check if the current item is active
            if (!$(this).parent().hasClass('active')) {
                _this.find('ul li').removeClass('active');
                $(this).parent().toggleClass('active');
            } else {
                $(this).parent().toggleClass('active');
            }
            e.preventDefault();
        });
    });

    $(window).on('resize', function(){
        $('.case-study-slider-wrapper').each(function(){
            var slider = $(this).find('.case-study-slider');
            var sliderIndicator = $(this).find('.case-study-slider-nav .slider-status');
            resizeSliderPos(slider, sliderIndicator);
        });
    });

    $('.wp-block-button.is-style-slide-to a').on('click', function(e){
        var target = $(this).attr('href');
        //check if the url is an anchor
        if (target.indexOf('#') == -1) {
            return;
        }
        $('html, body').animate({
            scrollTop: $(target).offset().top
        }, 500);
        e.preventDefault();
    });

    $('.flip-panel-wrapper').on('click', '.flip-panel-outer', function(e){
        $(this).toggleClass('rotate');
        e.preventDefault();
    });

    // function resizeGridItem(item){
    //     grid = document.getElementsByClassName("job-post-list")[0];
    //     rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
    //     rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'));
    //     rowSpan = Math.ceil((item.querySelector('.content').getBoundingClientRect().height+rowGap)/(rowHeight+rowGap));
    //     item.style.gridRowEnd = "span "+rowSpan;
    // }
    
    // function resizeAllGridItems(){
    //     allItems = document.getElementsByClassName("job-post-list-item");
    //     for(x=0;x<allItems.length;x++){
    //         resizeGridItem(allItems[x]);
    //     }
    // }
    
    // function resizeInstance(instance){
    //     item = instance.elements[0];
    //     resizeGridItem(item);
    // }
    
    // window.onload = resizeAllGridItems();
    // window.addEventListener("resize", resizeAllGridItems);
    
    // allItems = document.getElementsByClassName("item");
    // for(x=0;x<allItems.length;x++){
    //     imagesLoaded( allItems[x], resizeInstance);
    // }

    function resetSlider(target, initial = false) {
        var initial = initial || false;
        window.setTimeout(function() {
            var sliderTrack = target.find('.brand-slider');
            var slideGroup = target.find('.slide-holder');
            slideGroup.removeClass('clone').removeClass('animating');
            var numSlides = target.find('.slide-holder:first-child').children().length;
            var slideTime = numSlides * 3;
            var groupWidth = slideGroup[0].getBoundingClientRect().width;
            var sliderTrackWidth = sliderTrack[0].getBoundingClientRect().width;
            var currentSliderGroupWidth = groupWidth;
            var numSlidesAdded = 0;
            if (initial) {
                while (currentSliderGroupWidth < (sliderTrackWidth * 1.5) || numSlidesAdded < 1) {
                    var clone = target.find('.slide-holder:first-child').clone();
                    clone.addClass('clone');
                    sliderTrack.append(clone);
                    currentSliderGroupWidth += groupWidth;
                    numSlidesAdded++;
                }
            } else {
                var clone = target.find('.slide-holder:first-child').clone();
                clone.addClass('clone');
            }
            sliderTrack.append(clone);
            var firstSlide = sliderTrack.find('.slide-holder:first-child');
            sliderTrack.find('.slide-holder').attr('style', '--slide-duration:' + (slideTime) + 's').addClass('animating');
            window.setTimeout(function() {
                sliderTrack.find('.slide-holder:first-child').remove();
                resetSlider(target);
            }, ((slideTime) * 1000));
        }, 5);
    }

    $('.brand-slider-wrapper').each(function(){
        resetSlider($(this), true);
    });

    $('.job-post-list').on('click', '.panel-button a', function(e){
        $(this).parents('.panel').toggleClass('active');
        e.preventDefault();
    });

    $('#site-navigation .menu-item-has-children > a').on('click', function(e){
        if ($('.mobile-menu-header').is(':visible')) {
            if (!$(this).parents('div[class^="menu-"][class*="-container"]').hasClass('sub-menu-active')) {
                $(this).parents('div[class^="menu-"][class*="-container"]').addClass('sub-menu-active')
            } else {
                $(this).parents('div[class^="menu-"][class*="-container"]').removeClass('sub-menu-active')
            }
            $(this).parent().toggleClass('active');
        }
        e.preventDefault();
    });

    $('.footer-nav .menu-item-has-children > a').on('click', function(e){
        if (!$(this).parent().hasClass('active')) {
            $('.footer-nav .menu-item-has-children.active').removeClass('active');
        }
        $(this).parent().toggleClass('active');
        e.preventDefault();
    });


    $('#site-navigation .mobile-menu-header .back a').on('click', function(e){
        if ($('.mobile-menu-header').is(':visible')) {
            $(this).parents('div[class^="menu-"][class*="-container"]').removeClass('sub-menu-active');
            $(this).parents('div[class^="menu-"][class*="-container"]').find('.menu-item-has-children.active').removeClass('active');
        }
        e.preventDefault();
    });

    $('#site-navigation .mobile-menu-header .close a').on('click', function(e){
        if ($('.mobile-menu-header').is(':visible')) {
            $(this).parents('div[class^="menu-"][class*="-container"]').removeClass('sub-menu-active');
            $(this).parents('div[class^="menu-"][class*="-container"]').find('.menu-item-has-children.active').removeClass('active');
            $('#site-navigation').removeClass('toggled');
            closeMenu(e);
        }
        e.preventDefault();
    });

    $(window).on('resize', function(e){
        $('*').addClass('resizing');
        window.setTimeout(function(){
            $('.resizing').removeClass('resizing');
        }, 10);
        if (!$('.menu-toggle').is(':visible') && $('#site-navigation').hasClass('toggled')) {
            closeMenu(e);
        } else {
            if ($('#site-navigation').hasClass('toggled')) {
                openMenu(e);
            }
        }
    });

    function openMenu(e) {
        var scrollY = window.scrollY;
        jQuery('body').addClass('menu-visible');
        jQuery('body').css({'top': '-' + scrollY + 'px'});
        e.preventDefault();
        $('#site-navigation').addClass('toggled');
    }

    function openFilters(e) {
        $('.mobile-filters').addClass('active');
        $('.mobile-link').addClass('active');
        var scrollY = window.scrollY;
        jQuery('body').addClass('menu-visible');
        if ($('.archive-filters').is(':visible')) {
            jQuery('body').css({'top': - ($('.archive-filters').offset().top - $('#masthead').outerHeight()) + 'px'});
        } else {
            jQuery('body').css({'top': - ($('.vacancy-filters').offset().top - $('#masthead').outerHeight()) + 'px'});
        }
        e.preventDefault();
    }

    function closeMenu(e) {
        var scrollY = jQuery('body').css('top');
        jQuery('body').removeClass('menu-visible');
        jQuery('body').css({'top': ''});
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
        e.preventDefault();
        $('#site-navigation').removeClass('toggled');
    }

    function closeFilters(e) {
        e !== undefined ? e : false;
        $('a.mobile-link.active').removeClass('active');
        $('.mobile-filters').removeClass('active');
        if ($('.archive-filters').is(':visible')) {
            var scrollY = $('.archive-filters').position().top;
        } else {
            var scrollY = $('.vacancy-filters').position().top;
        }
        jQuery('body').removeClass('menu-visible');
        jQuery('body').css({'top': ''});
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
        if (e) {
            e.preventDefault();
        }
    }

    $('button.menu-toggle').on('click', function(e){
        if (!$('body').hasClass('menu-visible')) {
            openMenu(e);
        } else {    
            closeMenu(e);
        }
    });

    $('.featured-blocks-wrapper .mobile-wrapper > a').on('click', function(e){
        $(this).parent().toggleClass('active');
        e.preventDefault();
    });

    $('.has-mobile-filters .mobile-link, .mobile-filters .hide-filter a').on('click', function(e){
        if (!$('.mobile-filters').hasClass('active')) {
            openFilters(e);
        } else {
            closeFilters(e);
        }
        e.preventDefault();
    });

    $('.mobile-filters .hide-filter a').on('click', function(e){
        closeFilters(e);
        e.preventDefault();
    });

    // $(window).on('resize', function(e){
    //     if ($('.mobile-filters').is(':visible') && $('.mobile-filters').hasClass('active')) {
    //         closeFilters(e);
    //     }
    // });
    
    function checkScrollPos() {
        //check if current scroll position is greater than the top of the archive-filters element
        if ($('.mobile-filters').is(':visible')) {
            if ($('.archive-filters').is(':visible')) {
                if ($(window).scrollTop() > $('.archive-filters').offset().top) {
                    var topPadding = 0;
                } else {
                    var topPadding = ($('.archive-filters').offset().top - $('#masthead').height()) - $(window).scrollTop();
                }
            } else {
                if ($(window).scrollTop() > $('.vacancy-filters').offset().top) {
                    var topPadding = 0;
                } else {
                    var topPadding = ($('.vacancy-filters').offset().top - $('#masthead').height()) - $(window).scrollTop();
                }
            }

            //check how much of the footer is visible on the page
            var footerPos = $('#colophon').offset().top;
            var footerHeight = $('#colophon').height();
            var windowPos = $(window).scrollTop();
            var windowHeight = $(window).height();
            var footerVisible = (windowPos + windowHeight) - footerPos;
            //only take the value if it's positive
            footerVisible = (footerVisible > 0) ? footerVisible : 0;

            var headerHeight = $('#masthead').height();
            if ($('.archive-filters').is(':visible')) {
                var scrollBoxPadding = topPadding + footerVisible + headerHeight + $('.archive-filters').height();
            } else {
                var scrollBoxPadding = topPadding + footerVisible + headerHeight + $('.vacancy-filters').height();
            }
            $('.mobile-filters').css({'max-height': 'calc(100vh - ' + scrollBoxPadding + 'px)'});
        }
        requestAnimationFrame(checkScrollPos);
    }

    requestAnimationFrame(checkScrollPos);

    jQuery("body").on('click', '#ccc-icon', function(e){
        jQuery('.checkbox-toggle--slider .checkbox-toggle-input').each(function(){
            if (jQuery(this).is(':checked')) {
                jQuery(this).parents('label').addClass('checked');
            } else {
                jQuery(this).parents('label').removeClass('checked');
            }
        });
        e.preventDefault();
    });
    jQuery("body").on('change', '.checkbox-toggle--slider .checkbox-toggle-input', function(e){
        var $this = jQuery(this);
        window.setTimeout(function(){
            // console.log(parseInt($this.parents('label').find('.checkbox-toggle-toggle').css('left')));
            if (parseInt($this.parents('label').find('.checkbox-toggle-toggle').css('left')) > 0) {
                $this.parents('label').addClass('checked');
            } else {
                $this.parents('label').removeClass('checked');
            }
        }, 400);
        e.preventDefault();
    });

    $.fn.multiply = function(numCopies) {
        var newElements = this.clone();
        for(var i = 1; i < numCopies; i++)
        {
            newElements = newElements.add(this.clone());
        }
        return newElements;
    };

    function activateArchiveLoading() {
        $('.archive-post-wrapper').addClass('loading');
        $('.archive-post-wrapper').find('.post-type-output').remove();
        //if there are no posts, add some
        var template = $('.archive-post-wrapper-template').find('.post-type-output').eq(0).clone(true);
        var min_posts = $('input[name="posts_per_page"]').val();
        //make sure there is a minimum of min_posts posts
        var postCount = $('.archive-post-wrapper').find('.post-type-output').length;
        if (postCount < min_posts) {
            var diff = min_posts - postCount;
            template.multiply(diff).appendTo('.archive-post-wrapper');
        }
        if (!$('.featured-posts').parent('.post-wrapper').hasClass('hidden')) {
            if ($('.mobile-filters').hasClass('active')) {
                $('.featured-posts').parent('.post-wrapper').hide();
                jQuery('body').addClass('menu-visible');
                jQuery('body').css({'top': - ($('.archive-filters').position().top - $('#masthead').outerHeight()) + 'px'});
                $('.archive-page-header').removeClass('archive-page-header').addClass('archive-page-header-filtered');
            } else {
                $('.featured-posts').parent('.post-wrapper').slideUp(function(){
                    $(this).addClass('hidden');
                    $('.archive-page-header').removeClass('archive-page-header').addClass('archive-page-header-filtered')
                    //scroll to the archive-filters element
                    $('html, body').animate({
                        scrollTop: $('.archive-page-header-filtered').position().top - $('#masthead').outerHeight()
                    }, 1000);
                });
                $('.featured-posts').parent('.post-wrapper').parent().slideUp();
            }
        } else {
            //scroll to the archive-filters element
            $('html, body').animate({
                scrollTop: $('.archive-page-header-filtered').position().top - $('#masthead').outerHeight()
            }, 1000);
        }
    }

    function loadPosts() {
        var form = $('#post-filter-form');
        var formData = form.serialize();
        // console.log(formData);
        // $('.archive-post-wrapper').addClass('loading');
        activateArchiveLoading();
        // Ajax action returns json string
        $.ajax({
            url: ajax_object.ajax_url,
            data: formData,
            type: 'POST',
            dataType: 'json',
            success: function(response) {
                $('.archive-page-header h1').text(response.data.archive_title);
                $('.archive-page-header-filtered h1').text(response.data.archive_title);
                $('.pagination-wrapper').html(response.data.pagination);
                var loadedPosts = 0;
                var totalPosts = (response.data.posts != null) ? response.data.posts.length : 0;
                $('.archive-empty').removeClass('active');
                if (totalPosts == 0) {
                    $('.archive-empty').addClass('active');
                    $('.archive-post-wrapper').find('.post-type-output').remove();
                    $('.archive-post-wrapper').removeClass('loading');
                }
                for (postID in response.data.posts) {
                    index = response.data.posts.indexOf(response.data.posts[postID]);
                    var currentIndex = index + 1;
                    var child = $('.archive-post-wrapper').children(':nth-child(' + (currentIndex) + ')');
                    child.find('a').attr('href', response.data.posts[postID].permalink);
                    child.find('a').find('.post-image').html(response.data.posts[postID].featured_image);
                    var terms = response.data.posts[postID].terms;
                    var terms_html = '';
                    for (term in terms) {
                        terms_html += '<a class="btn btn-alt" href="' + terms[term].link + '">' + terms[term].name + '</a>';
                    }
                    child.find('.post-categories').html(terms_html);
                    var currentPostID = postID;
                    //once the image has loaded, add the loaded class
                    child.find('a').find('.post-image img').on('load', function(){
                        currentPostID = $(this).parents('.post-type-output').index() + 1;
                        var child = $('.archive-post-wrapper').children(':nth-child(' + (currentPostID) + ')');
                        child.addClass('loaded');
                        loadedPosts++;
                        if (loadedPosts == totalPosts) {
                            //remove any extra posts
                            $('.archive-post-wrapper').find('.post-type-output').slice(totalPosts).remove();
                            $('.archive-post-wrapper').removeClass('loading');
                            $('.archive-post-wrapper').find('.post-type-output').removeClass('loaded');
                        }
                    });
                    child.find('a').find('.post-content').html('<h5>' + response.data.posts[postID].title + '</h5>');
                }
            }
        });
    }

    $('#post-filter-form').find('select').bind('change', function(){
        var form = $('#post-filter-form');
        form.find('input[name="page"]').val(1);
        loadPosts();
    });

    $('.pagination-wrapper').on('click', 'a.page-numbers', function(e){
        e.preventDefault();
        var page = $(this).attr('href').split('/page/')[1];
        var form = $('#post-filter-form').length ? $('#post-filter-form') : $('#vacancy-filter-form');
        form.find('input[name="page"]').val(page);
        $('#post-filter-form').length ? loadPosts() : loadVacancies();
    });

    $('.filter-content-list ul li.reset a').on('click', function(e){
        var form = $('#post-filter-form');
        form.find('input[name="page"]').val(1);
        form.find('select').val(0);
        $('.filter-content-list > ul > li').each(function(){
            $(this).find('ul li.active').removeClass('active');
            $(this).find('ul li:first-child').addClass('active');
        });
        loadPosts();
        $('.hide-filter a').trigger('click');
        e.preventDefault();
    });

    $('.filter-content-list ul li ul li a').on('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        $(this).parents('ul:first').find('li.active').removeClass('active');
        if (!$(this).parent().hasClass('active')) {
            $(this).parent().toggleClass('active');
        }
        var select = $(this).parents('li').attr('data-select');
        var term = $(this).parents('li').attr('data-term');
        $('#' + select).val(term);
        loadPosts();
        // $('.hide-filter a').trigger('click');
    });

    $('.multi-select-dropdown > a').on('click', function(e){
        $(this).parent().toggleClass('active');
        e.preventDefault();
    });

    function activateVacanciesLoading() {
        $('.vacancy-post-wrapper').removeClass('hidden').addClass('loading');
        $('.vacancy-post-wrapper').find('.job-post-list-item').remove();
        //if there are no posts, add some
        var template = $('.vacancy-post-wrapper-template').find('.job-post-list-item').eq(0).clone(true);
        var min_posts = $('input[name="posts_per_page"]').val();
        //make sure there is a minimum of min_posts posts
        var postCount = $('.vacancy-post-wrapper').find('.job-post-list-item').length;
        if (postCount < min_posts) {
            var diff = min_posts - postCount;
            template.multiply(diff).appendTo('.job-post-list');
        }
        if ($('.mobile-filters').hasClass('active')) {
            jQuery('body').addClass('menu-visible');
            jQuery('body').css({'top': - ($('.vacancy-post-wrapper').position().top - ($('#masthead').outerHeight() + $('.vacancy-filters').outerHeight())) + 'px'});
        } else {
            $('html, body').animate({
                scrollTop: $('.vacancy-post-wrapper').position().top - ($('#masthead').outerHeight() +  + $('.vacancy-filters').outerHeight())
            }, 1000);
        }
    }

    function loadVacancies() {
        var form = $('#vacancy-filter-form');
        var formData = form.serialize();
        // console.log(formData);
        // $('.archive-post-wrapper').addClass('loading');
        activateVacanciesLoading();
        // Ajax action returns json string
        $.ajax({
            url: ajax_object.ajax_url,
            data: formData,
            type: 'POST',
            dataType: 'json',
            success: function(response) {
                console.log(response);
                $('.pagination-wrapper').html(response.data.pagination);
                var loadedPosts = 0;
                var totalPosts = (response.data.posts != null) ? response.data.posts.length : 0;
                $('.archive-empty').removeClass('active');
                if (totalPosts == 0) {
                    $('.archive-empty').addClass('active');
                    $('.vacancy-post-wrapper').addClass('hidden');
                    $('.vacancy-post-wrapper').find('.job-post-list-item').remove();
                    $('.vacancy-post-wrapper').removeClass('loading');
                }
                for (postID in response.data.posts) {
                    index = response.data.posts.indexOf(response.data.posts[postID]);
                    var currentIndex = index + 1;
                    var child = $('.job-post-list').children(':nth-child(' + (currentIndex) + ')');
                    child.find('.panel-more a').attr('href', response.data.posts[postID].permalink);
                    child.find('.panel-text h6').html(response.data.posts[postID].title);
                    child.addClass('loaded');
                    if (response.data.posts[postID].location != null) {
                        child.find('.panel-text span.location').html(response.data.posts[postID].location);
                    } else {
                        child.find('.panel-text span.location').remove();
                    }
                    if (response.data.posts[postID].salary != null) {
                        child.find('.panel-text .salary').html(response.data.posts[postID].salary);
                    } else {
                        child.find('.panel-text .salary').remove();
                    }
                    child.find('.panel-text .posted').html(response.data.posts[postID].posted);
                    child.find('.panel-more .excerpt').html(response.data.posts[postID].excerpt);
                    loadedPosts++;
                    if (loadedPosts == totalPosts) {
                        //remove any extra posts
                        $('.job-post-list').find('.job-post-list-item').slice(totalPosts).remove();
                        $('.vacancy-post-wrapper').removeClass('loading');
                        $('.vacancy-post-wrapper').find('.job-post-list-item').removeClass('loaded');
                    }
                }         
            }
        });
    }

    $('#vacancy-filter-form').find('input.trigger-checkbox-change').bind('change', function(){
        var form = $('#vacancy-filter-form');
        form.find('input[name="page"]').val(1);
        $('input[name="page"]').val(1);
        loadVacancies();
    });

    $('#mobile-remote-switch').on('change', function(e){
        //toggle the remote toggle switch on the form
        if ($(this).is(':checked')) {
            $('input[name="remote"]').prop('checked', true).triggerHandler('click');
        } else {
            $('input[name="remote"]').prop('checked', false).triggerHandler('click');
        }
        //trigger the change event on the select
        $('input[name="remote"]').trigger('change');
        e.preventDefault();
    });

    $('input[name="remote"]').on('change', function(e){
        if ($(this).is(':checked')) {
            $('#mobile-remote-switch').prop('checked', true);
        } else {
            $('#mobile-remote-switch').prop('checked', false);
        }
    });

    $('.mobile-filter-actions a.reset').on('click', function(e){
        e.preventDefault();
        $('input[id^="mobile-job-type-"]').prop('checked', false);
        $('input[id^="job-type-"]').prop('checked', false);
        $('input[name="remote"]').prop('checked', false);
        $('#mobile-remote-switch').prop('checked', false);
        $('input[name="page"]').val(1);
        loadVacancies();
        closeFilters(e);
    });

    $('input[id^="mobile-job-type-"]').on('change', function(e){
        //replace the 'mobile-job-type-' with 'job-type-'
        var id = $(this).attr('id').replace('mobile-job-type-', 'job-type-');
        if ($(this).is(':checked')) {
            $('#' + id).prop('checked', true).triggerHandler('click');
        } else {
            $('#' + id).prop('checked', false).triggerHandler('click');
        }
        $('#' + id).trigger('change');
        e.preventDefault();
    });

    $('input[id^="job-type-"]').on('change', function(e){
        //replace the 'job-type-' with 'mobile-job-type-'
        var id = $(this).attr('id');
        if ($(this).is(':checked')) {
            $('#mobile-' + id).prop('checked', true);
        } else {
            $('#mobile-' + id).prop('checked', false);
        }
    });


    $('#vacancy-filter-form').on('submit', function(e){
        e.preventDefault();
        loadVacancies();
    });

});